import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'createSourceGroup';
export const useCreateSourceGroupTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Добавить группу',
    on_success: 'Группа создана',
    on_error: 'Не удалось создать группу',
    create_source_group_form: {
      title: 'Новая группа источников',
      group_name: 'Название',
      description: 'Описание',
      owner_department: 'Подразделение владелец',
      permission_tag: 'Тег доступа',
      analytics_toast: 'Видеоаналитики и источники вы сможете добавить в группу на следующем шаге',
      on_cancel: 'Отмена',
      on_submit: 'Создать',
      validation: {
        required: 'Заполните обязательные поля',
        name_pattern: 'Допустимы латинские буквы, цифры, «-» и «_»',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Add group',
    on_success: 'Group created',
    on_error: 'Failed to create group',
    create_source_group_form: {
      title: 'New sources group',
      group_name: 'Name',
      description: 'Description',
      owner_department: 'Owner department',
      permission_tag: 'Permission tag',
      analytics_toast: 'You will be able to add video analytics and sources to the group in the next step',
      on_cancel: 'Cancel',
      on_submit: 'Create',
      validation: {
        required: 'Fill in the required fields',
        name_pattern: 'Only latin letters, digits, «-» and «_» are allowed',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Añadir grupo',
    on_success: 'Grupo creado',
    on_error: 'No se pudo crear el grupo',
    create_source_group_form: {
      title: 'Nuevo grupo de fuentes',
      group_name: 'Nombre',
      description: 'Descripción',
      owner_department: 'Departamento propietario',
      permission_tag: 'Etiqueta de permiso',
      analytics_toast: 'Podrá añadir videoanalíticas y fuentes al grupo en el siguiente paso',
      on_cancel: 'Cancelar',
      on_submit: 'Crear',
      validation: {
        required: 'Complete los campos obligatorios',
        name_pattern: 'Solo letras latinas, dígitos, «-» y «_»',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Adicionar grupo',
    on_success: 'Grupo criado',
    on_error: 'Falha ao criar grupo',
    create_source_group_form: {
      title: 'Novo grupo de fontes',
      group_name: 'Nome',
      description: 'Descrição',
      owner_department: 'Departamento proprietário',
      permission_tag: 'Etiqueta de permissão',
      analytics_toast: 'Você poderá adicionar videoanalíticas e fontes ao grupo na próxima etapa',
      on_cancel: 'Cancelar',
      on_submit: 'Criar',
      validation: {
        required: 'Preencha os campos obrigatórios',
        name_pattern: 'Apenas letras latinas, dígitos, «-» e «_»',
      },
    },
  },
}) : {}) as Record<string, unknown>;
